import React from 'react';
import { twMerge } from 'tailwind-merge';

export function Header3(props: React.HTMLAttributes<HTMLHeadingElement>) {
	return <h3 {...props} className={twMerge('text-base font-medium text-gray-900', props.className)} />;
}
